import { Typography } from 'antd';

const { Text } = Typography;

const LicensingFooter = () => (
  <div className="px-6 py-4 border-t border-theme-border">
    <Text strong className="text-sm leading-[22px] block mb-3 !text-theme-heading">Licensing</Text>
    <div className="flex items-center gap-3">
      <a
        href="https://creativecommons.org/licenses/by-nc-nd/4.0/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://licensebuttons.net/l/by-nc-nd/4.0/88x31.png"
          alt="CC BY-NC-ND 4.0"
          className="h-[31px]"
        />
      </a>
      <Text type="secondary" className="text-xs leading-[18px] !text-theme-muted">
        This evaluation data is licensed under{' '}
        <a
          href="https://creativecommons.org/licenses/by-nc-nd/4.0/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#1677ff] hover:underline"
        >
          Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
        </a>.
      </Text>
    </div>
  </div>
);

export default LicensingFooter;
